import queueClosureDispatcher from '../action';

const initialState = {
  list: [],
  listAffectedAppt: [],
  pagingAffectedAppt: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0,
  },
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0,
  },
};

const queueClosureReducer = queueClosureDispatcher(initialState, {
  [queueClosureDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined,
    },
  }),
  [queueClosureDispatcher.getDataAffectedApptSuccess]: (state, payload) => ({
    listAffectedAppt: payload.data.list,
    pagingAffectedAppt: {
      ...payload.data,
      list: undefined,
    },
  }),

  [queueClosureDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value,
  }),
  [queueClosureDispatcher.resetData]: (state, _) => ({
    ...initialState,
  }),
});

export default queueClosureReducer;
